import {
  createCheckoutTemplate as publicCreateCheckoutTemplate,
  getCheckoutTemplate as publicGetCheckoutTemplate,
  updateCheckoutTemplate as publicUpdateCheckoutTemplate,
  deleteCheckoutTemplate as publicDeleteCheckoutTemplate,
  queryCheckoutTemplates as publicQueryCheckoutTemplates,
  typedQueryCheckoutTemplates as publicTypedQueryCheckoutTemplates,
  createCheckoutFromTemplate as publicCreateCheckoutFromTemplate,
  createAndRedirectToCheckout as publicCreateAndRedirectToCheckout,
} from './ecom-v1-checkout-template-checkout-templates.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  CheckoutTemplateQuery,
  CheckoutTemplatesQueryBuilder,
  typedQueryCheckoutTemplates as universalTypedQueryCheckoutTemplates,
} from './ecom-v1-checkout-template-checkout-templates.universal.js';
import { onCheckoutTemplateCreated as publicOnCheckoutTemplateCreated } from './ecom-v1-checkout-template-checkout-templates.public.js';
import { onCheckoutTemplateDeleted as publicOnCheckoutTemplateDeleted } from './ecom-v1-checkout-template-checkout-templates.public.js';
import { onCheckoutTemplateUpdated as publicOnCheckoutTemplateUpdated } from './ecom-v1-checkout-template-checkout-templates.public.js';
import { onCheckoutTemplateUsed as publicOnCheckoutTemplateUsed } from './ecom-v1-checkout-template-checkout-templates.public.js';

function customQueryCheckoutTemplates(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryCheckoutTemplates(httpClient)(),
    typedQueryFunction: (query: CheckoutTemplateQuery) =>
      publicTypedQueryCheckoutTemplates(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): CheckoutTemplatesQueryBuilder;
  function overloadedQuery(
    query: CheckoutTemplateQuery
  ): ReturnType<typeof universalTypedQueryCheckoutTemplates>;
  function overloadedQuery(query?: CheckoutTemplateQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createCheckoutTemplate: MaybeContext<
  BuildRESTFunction<typeof publicCreateCheckoutTemplate> &
    typeof publicCreateCheckoutTemplate
> = /*#__PURE__*/ createRESTModule(publicCreateCheckoutTemplate);
export const getCheckoutTemplate: MaybeContext<
  BuildRESTFunction<typeof publicGetCheckoutTemplate> &
    typeof publicGetCheckoutTemplate
> = /*#__PURE__*/ createRESTModule(publicGetCheckoutTemplate);
export const updateCheckoutTemplate: MaybeContext<
  BuildRESTFunction<typeof publicUpdateCheckoutTemplate> &
    typeof publicUpdateCheckoutTemplate
> = /*#__PURE__*/ createRESTModule(publicUpdateCheckoutTemplate);
export const deleteCheckoutTemplate: MaybeContext<
  BuildRESTFunction<typeof publicDeleteCheckoutTemplate> &
    typeof publicDeleteCheckoutTemplate
> = /*#__PURE__*/ createRESTModule(publicDeleteCheckoutTemplate);
export const createCheckoutFromTemplate: MaybeContext<
  BuildRESTFunction<typeof publicCreateCheckoutFromTemplate> &
    typeof publicCreateCheckoutFromTemplate
> = /*#__PURE__*/ createRESTModule(publicCreateCheckoutFromTemplate);
export const createAndRedirectToCheckout: MaybeContext<
  BuildRESTFunction<typeof publicCreateAndRedirectToCheckout> &
    typeof publicCreateAndRedirectToCheckout
> = /*#__PURE__*/ createRESTModule(publicCreateAndRedirectToCheckout);
export const queryCheckoutTemplates: MaybeContext<
  BuildRESTFunction<typeof customQueryCheckoutTemplates> &
    typeof customQueryCheckoutTemplates
> = /*#__PURE__*/ createRESTModule(customQueryCheckoutTemplates);
/**
 * Triggered when a checkout template is created.
 */
export const onCheckoutTemplateCreated: BuildEventDefinition<
  typeof publicOnCheckoutTemplateCreated
> &
  typeof publicOnCheckoutTemplateCreated = createEventModule(
  publicOnCheckoutTemplateCreated
);
/**
 * Triggered when a checkout template is deleted.
 */
export const onCheckoutTemplateDeleted: BuildEventDefinition<
  typeof publicOnCheckoutTemplateDeleted
> &
  typeof publicOnCheckoutTemplateDeleted = createEventModule(
  publicOnCheckoutTemplateDeleted
);
/**
 * Triggered when a checkout template is updated.
 */
export const onCheckoutTemplateUpdated: BuildEventDefinition<
  typeof publicOnCheckoutTemplateUpdated
> &
  typeof publicOnCheckoutTemplateUpdated = createEventModule(
  publicOnCheckoutTemplateUpdated
);
/**
 * Triggered when a checkout is created from a checkout template.
 */
export const onCheckoutTemplateUsed: BuildEventDefinition<
  typeof publicOnCheckoutTemplateUsed
> &
  typeof publicOnCheckoutTemplateUsed = createEventModule(
  publicOnCheckoutTemplateUsed
);

export {
  Status,
  DescriptionLineType,
  DimensionsUnit,
  PaymentOptionType,
  ItemTypePreset,
  SubscriptionFrequency,
  FileType,
  TaxableAddressType,
  JurisdictionType,
  ItemAvailabilityStatus,
  PlatformFeeChargeType,
  VatType,
  PickupMethod,
  ChargeType,
  RuleType,
  DiscountType,
  WeightUnit,
  RateType,
  ManualCalculationReason,
  FallbackReason,
  ChannelType,
  BalanceType,
  AdditionalFeeSource,
  Severity,
  NameInOther,
  NameInLineItem,
  SuggestedFix,
  SortOrder,
  WebhookIdentityType,
} from './ecom-v1-checkout-template-checkout-templates.universal.js';
export {
  CheckoutTemplate,
  CheckoutCustomization,
  WebClientCustomization,
  V1LineItem,
  CatalogReference,
  CatalogOverrideFields,
  ProductName,
  DescriptionLine,
  DescriptionLineValueOneOf,
  DescriptionLineDescriptionLineValueOneOf,
  DescriptionLineName,
  PlainTextValue,
  Color,
  PhysicalProperties,
  Dimensions,
  PaymentOption,
  CustomLineItem,
  PriceDescription,
  ItemType,
  ItemTypeItemTypeDataOneOf,
  SubscriptionOptionInfo,
  SubscriptionSettings,
  FreeTrialPeriod,
  BillingSettings,
  Title,
  Description,
  SecuredMedia,
  ServiceProperties,
  Policy,
  TaxableAddress,
  TaxableAddressTaxableAddressDataOneOf,
  V1ModifierGroup,
  TranslatableString,
  V1ItemModifier,
  ExtendedFields,
  CustomContentReference,
  ExternalReference,
  CheckoutTemplateUsed,
  Checkout,
  LineItem,
  MultiCurrencyPrice,
  ItemTaxFullDetails,
  TaxRateBreakdown,
  TaxBreakdown,
  FocalPoint,
  ItemAvailabilityInfo,
  Scope,
  Group,
  ModifierGroup,
  ItemModifier,
  PlatformFee,
  AddressWithContact,
  Address,
  StreetAddress,
  AddressLocation,
  FullAddressContactDetails,
  VatId,
  ShippingInfo,
  SelectedCarrierServiceOption,
  DeliveryLogistics,
  PickupDetails,
  DeliveryTimeSlot,
  SelectedCarrierServiceOptionPrices,
  SelectedCarrierServiceOptionOtherCharge,
  DeliveryAllocation,
  Carrier,
  Region,
  ApplicableLineItems,
  ShippingRegion,
  CarrierServiceOption,
  ShippingOption,
  ShippingPrice,
  OtherCharge,
  BuyerInfo,
  BuyerInfoIdOneOf,
  PriceSummary,
  CalculationErrors,
  CalculationErrorsShippingCalculationErrorOneOf,
  Details,
  DetailsKindOneOf,
  ApplicationError,
  ValidationError,
  FieldViolation,
  SystemError,
  CarrierErrors,
  CarrierError,
  GiftCardCalculationError,
  GiftCard,
  AppliedDiscount,
  AppliedDiscountDiscountSourceOneOf,
  Coupon,
  MerchantDiscount,
  DiscountRule,
  DiscountRuleName,
  LineItemDiscount,
  ItemCombination,
  ItemCombinationLineItem,
  CustomField,
  TaxSummary,
  TaxCalculationDetails,
  TaxCalculationDetailsCalculationDetailsOneOf,
  AutoTaxFallbackCalculationDetails,
  AggregatedTaxBreakdown,
  CreatedBy,
  CreatedByIdOneOf,
  MembershipOptions,
  Membership,
  MembershipName,
  MembershipPaymentCredits,
  InvalidMembership,
  SelectedMemberships,
  SelectedMembership,
  AdditionalFee,
  ConversionInfo,
  Violation,
  Target,
  TargetTargetTypeOneOf,
  Other,
  TargetLineItem,
  CustomSettings,
  SubscriptionCharges,
  Charge,
  CreateCheckoutTemplateRequest,
  CreateCheckoutTemplateResponse,
  GetCheckoutTemplateRequest,
  GetCheckoutTemplateResponse,
  UpdateCheckoutTemplateRequest,
  UpdateCheckoutTemplateResponse,
  DeleteCheckoutTemplateRequest,
  DeleteCheckoutTemplateResponse,
  QueryCheckoutTemplatesRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryCheckoutTemplatesResponse,
  CursorPagingMetadata,
  Cursors,
  CreateCheckoutFromTemplateRequest,
  CreateCheckoutFromTemplateResponse,
  CreateAndRedirectToCheckoutRequest,
  RawHttpResponse,
  HeadersEntry,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  CheckoutTemplateCreatedEnvelope,
  CheckoutTemplateDeletedEnvelope,
  CheckoutTemplateUpdatedEnvelope,
  CheckoutTemplateUsedEnvelope,
  UpdateCheckoutTemplate,
  CheckoutTemplatesQueryResult,
  CheckoutTemplatesQueryBuilder,
  CheckoutTemplateQuerySpec,
} from './ecom-v1-checkout-template-checkout-templates.universal.js';
export { utils } from './ecom-v1-checkout-template-checkout-templates.universal.js';
export {
  StatusWithLiterals,
  DescriptionLineTypeWithLiterals,
  DimensionsUnitWithLiterals,
  PaymentOptionTypeWithLiterals,
  ItemTypePresetWithLiterals,
  SubscriptionFrequencyWithLiterals,
  FileTypeWithLiterals,
  TaxableAddressTypeWithLiterals,
  JurisdictionTypeWithLiterals,
  ItemAvailabilityStatusWithLiterals,
  PlatformFeeChargeTypeWithLiterals,
  VatTypeWithLiterals,
  PickupMethodWithLiterals,
  ChargeTypeWithLiterals,
  RuleTypeWithLiterals,
  DiscountTypeWithLiterals,
  WeightUnitWithLiterals,
  RateTypeWithLiterals,
  ManualCalculationReasonWithLiterals,
  FallbackReasonWithLiterals,
  ChannelTypeWithLiterals,
  BalanceTypeWithLiterals,
  AdditionalFeeSourceWithLiterals,
  SeverityWithLiterals,
  NameInOtherWithLiterals,
  NameInLineItemWithLiterals,
  SuggestedFixWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CreateCheckoutTemplateApplicationErrors,
  UpdateCheckoutTemplateApplicationErrors,
  CreateCheckoutFromTemplateApplicationErrors,
  CreateAndRedirectToCheckoutApplicationErrors,
  CommonQueryWithEntityContext,
  CheckoutTemplateQuery,
} from './ecom-v1-checkout-template-checkout-templates.universal.js';
